import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import { Perspective } from './types/Perspective';
import parts from './colors/components'
import { PricingService } from './pricing/PricingService'
import { Material } from './colors/materials'

Vue.use(Vuex)

const defaultColors = {...parts.ALL_BACK_PARTS, ...parts.ALL_FRONT_PARTS}

export default new Vuex.Store({
  state: {
    colors: defaultColors,
    perspective: Perspective.FRONT,
    price: PricingService.calculate(defaultColors)
  },
  getters: {
    getColors: (state) => state.colors,
    getPerspective: (state) => state.perspective,
    price: (state) => state.price
  },
  mutations: {
    setColor: (state, data) => {
      state.colors = {...state.colors, [data.name]: {color: data.newColor, material: data.material || Material.NONE_MATERIAL}}
      const newPrice = PricingService.calculate(state.colors)
      state.price = newPrice
    },
    setColors: (state, data) => {
        state.colors = data
        const newPrice = PricingService.calculate(state.colors)
        state.price = newPrice
    },
    setPerspective: (state, data) => {
        state.perspective = data
    },
    setOtherPerspective: (state) => {
        if (state.perspective === Perspective.FRONT) {
            state.perspective = Perspective.BACK
        } else {
            state.perspective = Perspective.FRONT
        }
    }
  },
//   plugins: [createPersistedState()]
});
